import * as React from 'react';
import { IconProps } from '../types';

const IcMenuSetting = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M8.935 3.099A1.5 1.5 0 0 1 10.38 2h4.24a1.5 1.5 0 0 1 1.445 1.099l.511 1.84 1.85-.477a1.5 1.5 0 0 1 1.674.702l2.12 3.672a1.5 1.5 0 0 1-.228 1.8L20.653 12l1.339 1.363a1.5 1.5 0 0 1 .228 1.801l-2.12 3.672a1.5 1.5 0 0 1-1.674.702l-1.85-.477-.51 1.84A1.5 1.5 0 0 1 14.62 22h-4.24a1.5 1.5 0 0 1-1.445-1.099l-.512-1.84-1.85.477a1.5 1.5 0 0 1-1.673-.702l-2.12-3.672a1.5 1.5 0 0 1 .229-1.8L4.347 12l-1.338-1.363a1.5 1.5 0 0 1-.23-1.801L4.9 5.164a1.5 1.5 0 0 1 1.675-.702l1.85.477.51-1.84Zm-.643 15.489ZM10.76 4l-.541 1.947a1.5 1.5 0 0 1-1.82 1.051l-1.957-.505-1.74 3.014 1.416 1.442a1.5 1.5 0 0 1 0 2.102l-1.416 1.442 1.74 3.014 1.957-.505a1.5 1.5 0 0 1 1.82 1.05L10.76 20h3.48l.54-1.948a1.5 1.5 0 0 1 1.821-1.05l1.957.505 1.74-3.014-1.416-1.442a1.5 1.5 0 0 1 0-2.102l1.416-1.442-1.74-3.014L16.601 7a1.5 1.5 0 0 1-1.82-1.051L14.24 4h-3.48Zm1.74 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuSetting;
